"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _statistic = require("@/api/statistic");

var _index2 = _interopRequireDefault(require("@/components/echartsNew/index"));

var _newToExcel = _interopRequireDefault(require("@/utils/newToExcel.js"));

var _permission = require("@/utils/permission");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// 权限判断函数
var _default = {
  components: {
    echartsNew: _index2.default
  },
  data: function data() {
    return {
      spinShow: false,
      grid: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 24,
        xs: 24
      },
      options: this.$timeOptions,
      name: "近30天",
      timeVal: [],
      fromList: this.$constants.timeList,
      dateLimit: '',
      dateLimitPram: {},
      list: [],
      optionData: {},
      style: {
        height: "400px"
      },
      pickerOptions: this.$timeOptions
    };
  },
  created: function created() {
    var end = new Date();
    var start = new Date();
    start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 29)));
    this.timeVal = [start, end];
  },
  mounted: function mounted() {
    this.dateLimit = 'lately7';
    this.dateLimitPram = 'lately7';
    this.getStatistics();
    this.getTrend();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.$set(this, 'dateLimitPram', e ? this.timeVal.join(",") : "");
    },
    selectChange: function selectChange(limit) {
      if (limit == '') {
        //昨天的时间
        var day1 = new Date();
        var day2 = new Date();
        day1.setTime(day1.getTime() - 48 * 60 * 60 * 1000);
        day2.setTime(day2.getTime() - 24 * 60 * 60 * 1000);
        var s1 = day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
        var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
        this.dateLimitPram = "".concat(s1, ",").concat(s2);
        this.getTrend();
        this.getStatistics();
      } else {
        this.dateLimitPram = limit;
        this.getTrend();
        this.getStatistics();
      }
    },
    onSeach: function onSeach() {
      this.getStatistics();
      this.getTrend();
    },
    exports: function () {
      var _exports = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee() {
        var th, filekey, data, fileName, lebData;
        return _index.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                th = [], filekey = [], data = [], fileName = "";
                _context.next = 3;
                return this.getExcelData();

              case 3:
                lebData = _context.sent;
                //表格主要数据
                if (!fileName) fileName = '交易统计表'; //文件名

                if (!filekey.length) {
                  filekey = lebData.filekey;
                }

                if (!th.length) th = lebData.header; //表头

                data = data.concat(lebData.exportData);
                (0, _newToExcel.default)(th, filekey, fileName, data);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exports() {
        return _exports.apply(this, arguments);
      }

      return exports;
    }(),
    getExcelData: function getExcelData(excelData) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        (0, _statistic.tradeTrendApi)({
          dateLimit: _this.dateLimitPram
        }).then(function (res) {
          var header = ['日期/时间', '营业额', "商品支付金额", '充值金额', '支出金额'];
          var filekey = ['date', 'turnover', 'proPayAmount', 'rechargeAmount', 'payoutAmount'];
          var exportData = new Array();
          exportData = res.map(function (item) {
            return {
              date: item.date,
              turnover: item.turnover,
              proPayAmount: item.proPayAmount,
              rechargeAmount: item.rechargeAmount,
              payoutAmount: item.payoutAmount
            };
          });
          resolve({
            header: header,
            filekey: filekey,
            exportData: exportData
          });
        });
      });
    },
    // 统计
    getStatistics: function getStatistics() {
      var _this2 = this;

      (0, _statistic.tradeOverviewApi)({
        dateLimit: this.dateLimitPram
      }).then(function (res) {
        var list = [{
          name: "营业额",
          icon: "iconyingyee1",
          info: '商品支付金额、充值金额、购买付费会员金额、线下收银金额',
          color: '#1890FF',
          class: 'one',
          list: {
            num: res.turnover,
            percent: res.turnoverRatio
          }
        }, {
          name: "商品支付金额",
          icon: "iconshangpinzhifujine1",
          info: '选定条件下，用户购买商品的实际支付金额，包括微信支付、余额支付、支付宝支付、线下支付金额（拼团商品在成团之后计入，线下支付订单在后台确认支付后计入）',
          color: '#A277FF',
          class: 'two',
          list: {
            num: res.proPayAmount,
            percent: res.proPayAmountRatio
          }
        }, {
          name: "充值金额",
          icon: "iconchongzhijine",
          info: '选定条件下，用户成功充值的金额',
          color: '#EF9C20',
          class: 'three',
          list: {
            num: res.rechargeAmount,
            percent: res.rechargeAmountRatio
          }
        }, {
          name: "支出金额",
          icon: "iconzhichujine1",
          info: '余额支付金额、支付佣金金额、商品退款金额',
          color: '#1BBE6B',
          class: 'four',
          list: {
            num: res.payoutAmount,
            percent: res.payoutAmountRatio
          }
        }, {
          name: "余额支付金额",
          icon: "iconyuezhifujine1",
          info: '用户下单时使用余额实际支付的金额',
          color: '#4BCAD5',
          class: 'five',
          list: {
            num: res.balanceAmount,
            percent: res.balanceAmountRatio
          }
        }, {
          name: "支付佣金金额",
          icon: "iconzhifuyongjinjine1",
          info: '后台给推广员支付的推广佣金，以实际支付为准',
          color: '#EF9C20',
          class: 'six',
          list: {
            num: res.payoutBrokerageAmount,
            percent: res.payoutBrokerageAmountRatio
          }
        }, {
          name: "商品退款金额",
          icon: "iconshangpintuikuanjine",
          info: '用户成功退款的商品金额',
          color: '#1890FF',
          class: 'one',
          list: {
            num: res.proRefundAmount,
            percent: res.proRefundAmountRatio
          }
        }];
        _this2.list = list.map(function (item) {
          return {
            name: item.name,
            icon: item.icon,
            list: item.list,
            info: item.info,
            color: item.color,
            class: item.class,
            ratio: item.list.percent.replace("%", "") / 100
          };
        });
      });
    },
    // 统计图
    getTrend: function getTrend() {
      var _this3 = this;

      (0, _statistic.tradeTrendApi)({
        dateLimit: this.dateLimitPram
      }).then(function (res) {
        var xAxis = new Array();
        var series = [{
          "name": "营业额",
          "data": [],
          "type": "line",
          "smooth": "true",
          "yAxisIndex": 0
        }, {
          "name": "商品支付金额",
          "data": [],
          "type": "line",
          "smooth": "true",
          "yAxisIndex": 0
        }, {
          "name": "充值金额",
          "data": [],
          "type": "line",
          "smooth": "true",
          "yAxisIndex": 0
        }, {
          "name": "支出金额",
          "data": [],
          "type": "line",
          "smooth": "true",
          "yAxisIndex": 0
        }];
        xAxis = res.map(function (item) {
          return item.date;
        });
        series[0].data = res.map(function (item) {
          return item.turnover;
        });
        series[1].data = res.map(function (item) {
          return item.proPayAmount;
        });
        series[2].data = res.map(function (item) {
          return item.rechargeAmount;
        });
        series[3].data = res.map(function (item) {
          return item.payoutAmount;
        });
        _this3.spinShow = true;
        var legend = series.map(function (item) {
          return item.name;
        });
        var col = ["#B37FEB", "#FFAB2B", "#1890FF", "#00C050"];
        series.map(function (item, index) {
          item.itemStyle = {
            normal: {
              color: col[index]
            }
          };
        });
        _this3.optionData = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            x: 'center',
            data: legend
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            // axisTick:{
            //     show:false
            // },
            // axisLine:{
            //     show:false
            // },
            // splitLine: {
            //     show: false
            // },
            axisLabel: {
              interval: 0,
              rotate: 40,
              textStyle: {
                color: '#000000'
              }
            },
            data: xAxis
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#7F8B9C'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#F5F7F9'
              }
            }
          },
          series: series
        };
        _this3.spinShow = false;
      });
    }
  }
};
exports.default = _default;